function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.101 5L.38 2.278A1.05 1.05 0 111.864.793l3.465 3.465a1.047 1.047 0 010 1.484L1.864 9.207A1.05 1.05 0 11.379 7.722L3.1 5z",
  fill: "#748999",
  fillRule: "evenodd"
});

var SvgSeparator = function SvgSeparator(props) {
  return React.createElement("svg", _extends({
    width: 6,
    height: 10
  }, props), _ref);
};

export default SvgSeparator;